<template>
  <!-- vee 3 observer bileşeninin kullanılan alt kümesi (Aşama 2.2). Kök <span> aynı DOM'u korur.
       İçindeki ValidationField'lar ve iç içe ValidationForm'lar inject ile kaydolur. -->
  <component :is="tag"><slot :invalid="invalid" :handleSubmit="handleSubmit" /></component>
</template>

<script>
  export default {
    name: 'ValidationForm',
    emits: [],
    provide() {
      return { validationForm: this };
    },
    inject: {
      validationForm: { default: null }
    },
    props: {
      tag: { type: String, default: 'span' }
    },
    data() {
      return {
        fields: []
      };
    },
    computed: {
      invalid() {
        return this.fields.some(field => field.invalid);
      }
    },
    created() {
      if (this.validationForm) this.validationForm.register(this);
    },
    beforeUnmount() {
      if (this.validationForm) this.validationForm.unregister(this);
    },
    methods: {
      register(field) {
        if (!this.fields.includes(field)) this.fields.push(field);
      },
      unregister(field) {
        const index = this.fields.indexOf(field);
        if (index !== -1) this.fields.splice(index, 1);
      },
      /* Tüm alanları doğrular ve hataları gösterir. */
      validate() {
        return Promise.all(this.fields.map(field => field.validate()))
          .then(results => results.every(result => result === true || (result && result.valid === true)));
      },
      handleSubmit(callback) {
        return this.validate().then(isValid => (isValid && callback ? callback() : undefined));
      },
      reset() {
        this.fields.forEach(field => field.reset());
      }
    }
  };
</script>
